/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../../../spine/options_pb.js');
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
var spine_core_command_pb = require('../../../../spine/core/command_pb.js');
goog.exportSymbol('proto.spine.system.server.ScheduledCommandRecord', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.ScheduledCommandRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.ScheduledCommandRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.ScheduledCommandRecord.displayName = 'proto.spine.system.server.ScheduledCommandRecord';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.ScheduledCommandRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.ScheduledCommandRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.ScheduledCommandRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.ScheduledCommandRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && spine_core_command_pb.CommandId.toObject(includeInstance, f),
    command: (f = msg.getCommand()) && spine_core_command_pb.Command.toObject(includeInstance, f),
    schedulingTime: (f = msg.getSchedulingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.ScheduledCommandRecord}
 */
proto.spine.system.server.ScheduledCommandRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.ScheduledCommandRecord;
  return proto.spine.system.server.ScheduledCommandRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.ScheduledCommandRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.ScheduledCommandRecord}
 */
proto.spine.system.server.ScheduledCommandRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_core_command_pb.CommandId;
      reader.readMessage(value,spine_core_command_pb.CommandId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new spine_core_command_pb.Command;
      reader.readMessage(value,spine_core_command_pb.Command.deserializeBinaryFromReader);
      msg.setCommand(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSchedulingTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.ScheduledCommandRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.ScheduledCommandRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.ScheduledCommandRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.ScheduledCommandRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_core_command_pb.CommandId.serializeBinaryToWriter
    );
  }
  f = message.getCommand();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_core_command_pb.Command.serializeBinaryToWriter
    );
  }
  f = message.getSchedulingTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional spine.core.CommandId id = 1;
 * @return {?proto.spine.core.CommandId}
 */
proto.spine.system.server.ScheduledCommandRecord.prototype.getId = function() {
  return /** @type{?proto.spine.core.CommandId} */ (
    jspb.Message.getWrapperField(this, spine_core_command_pb.CommandId, 1));
};


/** @param {?proto.spine.core.CommandId|undefined} value */
proto.spine.system.server.ScheduledCommandRecord.prototype.setId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.ScheduledCommandRecord.prototype.clearId = function() {
  this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.ScheduledCommandRecord.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional spine.core.Command command = 2;
 * @return {?proto.spine.core.Command}
 */
proto.spine.system.server.ScheduledCommandRecord.prototype.getCommand = function() {
  return /** @type{?proto.spine.core.Command} */ (
    jspb.Message.getWrapperField(this, spine_core_command_pb.Command, 2));
};


/** @param {?proto.spine.core.Command|undefined} value */
proto.spine.system.server.ScheduledCommandRecord.prototype.setCommand = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.system.server.ScheduledCommandRecord.prototype.clearCommand = function() {
  this.setCommand(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.ScheduledCommandRecord.prototype.hasCommand = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp scheduling_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.spine.system.server.ScheduledCommandRecord.prototype.getSchedulingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.spine.system.server.ScheduledCommandRecord.prototype.setSchedulingTime = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.spine.system.server.ScheduledCommandRecord.prototype.clearSchedulingTime = function() {
  this.setSchedulingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.ScheduledCommandRecord.prototype.hasSchedulingTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


goog.object.extend(exports, proto.spine.system.server);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../../../known_type_parsers.js');

proto.spine.system.server.ScheduledCommandRecord.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.ScheduledCommandRecord.fromObject(jsObject);
};

proto.spine.system.server.ScheduledCommandRecord.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.ScheduledCommandRecord();
  
  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      let value = proto.spine.core.CommandId.fromObject(obj.id);
      msg.setId(value);
    }
  }
  
  if (obj.command !== undefined) {
    if (obj.command === null) {
      msg.setCommand(null);
    } else {
      let value = proto.spine.core.Command.fromObject(obj.command);
      msg.setCommand(value);
    }
  }
  
  if (obj.schedulingTime !== undefined) {
    if (obj.schedulingTime === null) {
      msg.setSchedulingTime(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Timestamp');
      let value = parser.parse(obj.schedulingTime);
      msg.setSchedulingTime(value);
    }
  }
  return msg;
};
